import VideoModal from './VideoModal.vue'

export default VideoModal
